import React from 'react'

import Box from 'components_new/atoms/Box'
import Text from 'components_new/atoms/Text'

interface DataRerunJobNameProps {
  jobName: string
  label: string
}

/** A job's Swedish name with its Glue job name under it. */
const DataRerunJobName = (props: DataRerunJobNameProps) => {
  const { jobName, label } = props

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
      <Text variant="body2">{label}</Text>
      <Text
        sx={{ color: 'text.secondary', fontFamily: 'monospace', fontSize: 11 }}
        variant="caption"
      >
        {jobName}
      </Text>
    </Box>
  )
}

DataRerunJobName.displayName = 'DataRerunJobName'
export default DataRerunJobName
